import * as React from 'react';
import {Checkbox} from 'semantic-ui-react';
import {observer} from 'mobx-react';
import {showHidePackage} from '../actions/Field';
import {getLocalizedText, texts, categoryDesc} from '../../../../constants/TextConst';

import * as fieldTypes from '../../../../constants/FieldTypes';

@observer
class PackagesMenu extends React.Component<any, any> {
    renderTitle() {
        return <div className="pack-title">{this.props.designScreen.selected.title}</div>;
    }

    renderDescription() {
        const {designScreen} = this.props;
        const {selected} = designScreen;
        let desc = selected.description;

        if (selected && (selected.type as string) === 'tab') {
            desc =
                designScreen && categoryDesc[selected.title] && categoryDesc[selected.title].desc;
        }

        return <p className="description">{desc}</p>;
    }

    showHidePackage(isShow) {
        const {designScreen} = this.props;
        showHidePackage(designScreen.selected, isShow);
    }

    renderCheckboxes() {
        const {selected} = this.props.designScreen;
        const {type, status, marked, sum} = selected;

        let isShowChecked = false;
        let isHideChecked = false;
        let showText = getLocalizedText(texts.showPackTxt);
        let hideText = getLocalizedText(texts.hidePackTxt);

        if (type === fieldTypes.TAB) {
            // TODO: When license via packages will be supported need to update this check
            isShowChecked = sum === marked;
            isHideChecked = marked === 0;
            showText = getLocalizedText(texts.showCategoryTxt);
            hideText = getLocalizedText(texts.hideCategoryTxt);
        } else {
            isShowChecked = status;
            isHideChecked = !status;
        }

        return (
            <div className="checkboxes-wrapper">
                <div className="show-checkbox">
                    <Checkbox
                        radio
                        name="checkboxRadioGroup"
                        value="formHide"
                        checked={isShowChecked}
                        onChange={() => {
                            this.showHidePackage(true);
                        }}
                    />
                    <span>{showText}</span>
                </div>
                <div className="hide-checkbox">
                    <Checkbox
                        radio
                        name="checkboxRadioGroup"
                        value="formShow"
                        checked={isHideChecked}
                        onChange={() => {
                            this.showHidePackage(false);
                        }}
                    />
                    <span>{hideText}</span>
                </div>
            </div>
        );
    }

    render() {
        // TODO: check if we still need this
        if (
            !this.props.designScreen.selected ||
            !this.props.designScreen.selected.collection.hasExpendedTab
        ) {
            return null;
        }

        return (
            <div className="field-actions">
                <div className="actions-wrapper">
                    {this.renderTitle()}
                    {this.renderDescription()}
                    {this.renderCheckboxes()}
                </div>
            </div>
        );
    }
}

export default PackagesMenu;
